export default __webpack_public_path__ + "static/media/polzL.d2c84ba0.jpg";